import { Container } from 'lucide-react';

import { Heading } from '@/components/heading';
import { Icon } from '@/components/icon';
import { MODE_AIR, MODE_WATER } from '@/lib/constants';
import { SegmentModeType } from '@/types/api-types';
import { tv } from '@/utils/styles';

interface RatesRouteBadgeProps {
  mode: SegmentModeType;
  label?: string;
  variant?: 'default' | 'transparent';
}

const RatesRouteBadge = ({ label = '', mode, variant = 'default' }: RatesRouteBadgeProps) => {
  const { base, icon, routePortCodes } = styles({ variant });

  return (
    <div className={base()}>
      <div className={icon()}>
        {mode === MODE_AIR && <Icon color="grey.700" size="16px" name="plane" />}
        {mode === MODE_WATER && <Container className="size-4 text-grey-700" />}
      </div>
      <Heading as="h3" variant="h5" className={routePortCodes()}>
        {label}
      </Heading>
    </div>
  );
};

const styles = tv({
  slots: {
    base: '-ml-1 inline-flex items-center gap-1.5 rounded-lg px-2 py-1 pl-2 pr-1.5 leading-tight text-text-primary',
    routePortCodes: 'mb-0 text-sm',
    icon: 'flex',
  },
  variants: {
    variant: {
      default: {
        base: 'bg-grey-100',
        routePortCodes: 'text-sm',
      },
      transparent: {
        base: 'ml-0 gap-2 bg-transparent p-0',
        routePortCodes: 'text-sm md:text-baseSm',
      },
    },
  },
});

export { RatesRouteBadge };
